import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AnsokanFormGroupService } from 'src/app/service/ansokan-form-group/ansokan-form-group.service';
import { APPLICATION_NAMES, PAGE_NAMES } from '../../../service/ansokan-form-builder/application-names';

@Component({
    selector: 'app-contact-info',
    styleUrls: ['./contact-info.component.scss'],
    templateUrl: './contact-info.component.html',
    standalone: false
})
export class ContactInfoComponent implements OnInit {

  public address: UntypedFormControl;
  public phone: UntypedFormControl;
  private group: UntypedFormGroup;
  public error: boolean;

  public get supplementApplication(): boolean {
    const type: string = this.formGroupService.get(APPLICATION_NAMES.APPLICATION_TYPE).value;
    return type && type.indexOf('SUP') !== -1;
  }

  constructor(
    private formGroupService: AnsokanFormGroupService,
  ) { }

  public ngOnInit() {
    // Get form controls.
    this.group = this.formGroupService.get(PAGE_NAMES.APPLICANT.KEY) as UntypedFormGroup;
    this.address = this.group.get(PAGE_NAMES.APPLICANT.ADDRESS) as UntypedFormControl;
    this.phone = this.group.get(PAGE_NAMES.APPLICANT.PHONE) as UntypedFormControl;
  }
}
